import type { SelectOption, SelectOptions } from '@library/types/utils';
import type { ProjectionRelationshipDataType } from '@library/types/projection';
import { Select } from '@library/components/selects';

interface RankDrawerStatTypeSelectProps {
  handleSelectStatType: (value: SelectOption) => void;
  selectedStatType: ProjectionRelationshipDataType['id'];
  statOptions: SelectOptions;
}

export const RankDrawerStatTypeSelect = ({
  selectedStatType,
  handleSelectStatType,
  statOptions
}: RankDrawerStatTypeSelectProps) => (
  <div className="px-6 pt-10">
    <span className="text-soClean-100 text-xs font-bold">STAT TYPE</span>

    <Select
      className="w-full text-sm font-normal"
      label="Stat Types"
      onChange={handleSelectStatType}
      options={statOptions}
      size="large"
      value={selectedStatType}
      zIndex={200}
    />
  </div>
);
